import { StartupErrorBoundary } from "@-/dev.improve.haniverse.components.error.startup";
import { type ComponentType, type PropsWithChildren } from "react";
import { RootContext } from "#root-context";
import {
  RootLayoutProviders,
  type RootLayoutNavigationDevtoolsProps,
  type UseRootLayoutNavigationDevtoolsGate,
  type UseRootLayoutShellDevtools,
} from "#root-layout-providers";
import { useRootContextValue } from "#use-root-context-value";
import { AppPostHogProvider } from "@-/dev.improve.haniverse.lib.posthog";

function RootContextInner({ children }: PropsWithChildren) {
  const value = useRootContextValue();
  return <RootContext.Provider value={value}>{children}</RootContext.Provider>;
}

export function RootContextProvider({
  children,
  NavigationDevtools,
  useNavigationDevtoolsGate,
  useShellDevtools,
}: PropsWithChildren<{
  NavigationDevtools?: ComponentType<RootLayoutNavigationDevtoolsProps>;
  useNavigationDevtoolsGate?: UseRootLayoutNavigationDevtoolsGate;
  useShellDevtools?: UseRootLayoutShellDevtools;
}>) {
  return (
    <StartupErrorBoundary>
      <RootContextInner>
        <RootLayoutProviders
          NavigationDevtools={NavigationDevtools}
          useNavigationDevtoolsGate={useNavigationDevtoolsGate}
          useShellDevtools={useShellDevtools}
        >
          <AppPostHogProvider>{children}</AppPostHogProvider>
        </RootLayoutProviders>
      </RootContextInner>
    </StartupErrorBoundary>
  );
}
